import { Banner, Button, Tag } from '@dev-spendesk/grapes';
import { useHistory } from 'react-router-dom';

import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { routeFor, routes } from 'src/core/constants/routes';

type Props = {
  className?: string;
};

export const RulesPromoBanner = ({ className }: Props) => {
  const history = useHistory();
  const companyId = useCompanyId();
  const { t } = useTranslation('global');

  return (
    <Banner
      className={className}
      variant="neutral"
      title={
        <div className="flex items-center gap-8">
          <span className="title-l">
            {t('bookkeep.integrations.settings.payableRules.promoBannerTitle')}
          </span>
          <Tag variant="lemon">{t('misc.new')}</Tag>
        </div>
      }
      actions={
        <Button
          variant="secondaryNeutral"
          text={t('bookkeep.integrations.settings.payableRules.promoBannerCta')}
          onClick={() => {
            history.push(
              routeFor(routes.COMPANY_ACCOUNTING_PAYABLE_RULES_SETUP.path, {
                company: companyId,
              }),
            );
          }}
        />
      }
    >
      {t('bookkeep.integrations.settings.payableRules.promoBannerContent')}
    </Banner>
  );
};
